import React, { useState } from 'react';

import { DynamicIconWrapper, Icons, Modal, Tooltip } from '@components/common';
import TextAvatar from '@components/common/TextAvatar';
import OrganisationInfo from '@components/ModalComponents/OrganisationInfo';

import styles from './AssetOwnerInfo.module.scss';

interface IAssetOwnerInfo {
	owner: {
		id: string;
		name: string;
		avatar: {
			id: string;
		};
	};
}

const AssetOwnerInfo = ({
	owner,
}: IAssetOwnerInfo) => {
	const [isOrganisationInfoWindow, setIsOrganisationInfoWindow] = useState(false);

	const toggleOrganisationInfo = () => setIsOrganisationInfoWindow(!isOrganisationInfoWindow);

	return (
		<div className={styles.assetOwnerInfo}>
			<TextAvatar
				avatarId={owner?.avatar?.id}
				fontSize='20px'
				fullName={owner.name}
				isProfileLogo
				size='75px'
			/>
			<div className={styles.info}>
				<div className={styles.name}>
					{owner.name}
					<Tooltip content={<span>Click to see details</span>}>
						<div
							className={styles.infoIcon}
							onClick={toggleOrganisationInfo}
						>
							<DynamicIconWrapper icon={Icons.info} />
						</div>
					</Tooltip>
				</div>
			</div>
			<Modal
				isOpen={isOrganisationInfoWindow}
				isScrollableContent
				isTitleHidden
				onClose={toggleOrganisationInfo}
				width='640px'
			>
				<OrganisationInfo id={owner?.id} />
			</Modal>

		</div>
	);
};

export default AssetOwnerInfo;
